import { firstArray } from "../support/supportFormatters";

export const workspaceModel = (snapshot = {}, routeId = null) => {
  snapshot = snapshot && typeof snapshot === "object" ? snapshot : {};
  const store = snapshot.store || snapshot.storeDetails || snapshot.details || {};
  const health = snapshot.health || snapshot.supportHealth || {};
  const pipeline = snapshot.pipeline || snapshot.sync || store.pipeline || health.pipeline || {};
  const connections = snapshot.connections || store.connections || {};
  const billing = snapshot.billing || snapshot.usageBilling || store.billing || {};
  const configuration = snapshot.configuration || snapshot.settings || store.configuration || {};
  const lifecycle = snapshot.lifecycle || store.lifecycle || {};
  const onboarding = snapshot.onboarding || store.onboarding || snapshot.lifecycle || {};
  const disputesValue =
    snapshot.disputes && typeof snapshot.disputes === "object" && !Array.isArray(snapshot.disputes)
      ? snapshot.disputes
      : snapshot.disputeSummary || store.disputes || {};
  const paypalAccounts = firstArray(
    connections.paypal?.accounts,
    snapshot.paypalAccounts,
    configuration.paypalAccounts
  );
  const recentDisputes = firstArray(
    snapshot.recentDisputes,
    Array.isArray(snapshot.disputes) ? snapshot.disputes : null,
    disputesValue.cases,
    disputesValue.recent
  );

  return {
    observedAt: snapshot.observedAt || health.observedAt || null,
    store: {
      ...store,
      id: store.id ?? store.shopId ?? snapshot.shopId ?? routeId,
      name: store.name || store.storeName || snapshot.storeName,
      myShopifyDomain:
        store.myShopifyDomain || store.shopDomain || store.domain || snapshot.shopDomain,
    },
    health: {
      ...health,
      status: health.status || snapshot.status || store.healthStatus || store.health || "UNKNOWN",
      summary:
        health.summary ||
        snapshot.summary ||
        (Array.isArray(snapshot.issues) && snapshot.issues.length
          ? snapshot.issues[0]?.summary
          : null) ||
        "No store diagnosis was returned.",
    },
    pipeline,
    connections: {
      shopify: connections.shopify || snapshot.shopify || {},
      paypal: connections.paypal || snapshot.paypal || {},
    },
    billing,
    configuration,
    lifecycle: {
      ...lifecycle,
      active: lifecycle.active ?? store.active ?? store.state,
      installedAt: lifecycle.installedAt || store.installedAt || store.creationDate,
      lastActivityAt: lifecycle.lastActivityAt || store.lastActivityAt,
      lastImportedAt: lifecycle.lastImportedAt || store.lastImportedAt,
      lastSyncedAt: lifecycle.lastSyncedAt || store.lastSyncedAt,
      lastProcessedAtPullAt:
        lifecycle.lastProcessedAtPullAt || store.lastProcessedAtPullAt,
      lastPullStatus: lifecycle.lastPullStatus || store.lastPullStatus,
      lastPullErrorAt: lifecycle.lastPullErrorAt || store.lastPullErrorAt,
      deactivatedAt: lifecycle.deactivatedAt || store.deactivatedAt,
      deactivationReason: lifecycle.deactivationReason || store.deactivationReason,
    },
    onboarding: {
      ...onboarding,
      status:
        onboarding.status ||
        store.onboardingStatus ||
        (onboarding.completedAt || store.onboardingCompletedAt
          ? "COMPLETED"
          : onboarding.startedAt || store.onboardingStartedAt
          ? "IN_PROGRESS"
          : "UNTRACKED"),
      startedAt: onboarding.startedAt || store.onboardingStartedAt,
      currentStep: onboarding.currentStep ?? store.onboardingCurrentStep,
      deferredAt: onboarding.deferredAt || store.onboardingDeferredAt,
      completedAt: onboarding.completedAt || store.onboardingCompletedAt,
      guideExpiresAt: onboarding.guideExpiresAt || store.onboardingGuideExpiresAt,
      historyDays: onboarding.historyDays ?? store.onboardingHistoryDays,
      importStatus: onboarding.importStatus || store.onboardingImportStatus,
      importedOrders: onboarding.importedOrders ?? store.onboardingImportedOrders,
      importTotalOrders: onboarding.importTotalOrders ?? store.onboardingImportTotalOrders,
      importPendingOrders: onboarding.importPendingOrders ?? store.onboardingImportPendingOrders,
      showGuide: onboarding.showGuide ?? onboarding.guideVisible,
      guideVisible: onboarding.guideVisible ?? onboarding.showGuide,
      paypalConnected: onboarding.paypalConnected,
      autoSyncEnabled: onboarding.autoSyncEnabled,
      merchantScreen:
        onboarding.merchantScreen ||
        store.merchantScreen ||
        (onboarding.completedAt || store.onboardingCompletedAt
          ? "DASHBOARD"
          : onboarding.startedAt || store.onboardingStartedAt
          ? "ONBOARDING"
          : "LEGACY_DASHBOARD"),
    },
    disputes: {
      ...disputesValue,
      total: disputesValue.total ?? store.totalDisputes,
      open: disputesValue.open ?? store.openDisputes,
      attention:
        disputesValue.attention ??
        disputesValue.responseDue ??
        store.disputesNeedingAttention,
      overdue: disputesValue.overdue ?? store.overdueDisputes,
      underReview: disputesValue.underReview ?? store.disputesUnderReview,
      won: disputesValue.won ?? store.disputesWon,
      lost: disputesValue.lost ?? store.disputesLost,
      lastSyncedAt: disputesValue.lastSyncedAt || store.disputesLastSyncedAt,
      syncStatus: disputesValue.syncStatus || store.disputesSyncStatus,
      syncError: disputesValue.syncError || store.disputesSyncError,
      dueWithin24Hours:
        disputesValue.dueWithin24Hours ?? store.disputesDueWithin24Hours,
      failedActions: disputesValue.failedActions ?? store.failedDisputeActions,
      pendingWebhookEvents:
        disputesValue.pendingWebhookEvents ?? store.pendingDisputeWebhookEvents,
      failedWebhookEvents:
        disputesValue.failedWebhookEvents ?? store.failedDisputeWebhookEvents,
    },
    capabilities: snapshot.capabilities || {},
    issues: firstArray(health.issues, snapshot.issues),
    recommendedActions: firstArray(
      health.recommendedActions,
      snapshot.recommendedActions,
      snapshot.actions
    ),
    recentActivity: firstArray(
      snapshot.recentActivity,
      snapshot.activity,
      pipeline.recentActivity,
      pipeline.recentSyncs
    ),
    paypalAccounts,
    carrierRules: firstArray(
      configuration.carrierRules,
      snapshot.carrierRules,
      snapshot.carrierMappings,
      snapshot.courierMappings
    ),
    recentOrders: firstArray(snapshot.recentOrders, pipeline.recentOrders),
    recentDisputes,
    operationalIncidents: firstArray(
      snapshot.operationalIncidents,
      snapshot.incidents,
      health.incidents
    ),
  };
};
